import {
  faCheckCircle,
  faMinusCircle,
  faPlusCircle,
  faTrashAlt
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _ from 'lodash';
import React, { Component } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { connect } from 'react-redux';
import { Button, Input, Label } from 'reactstrap';
import styled from 'styled-components';
import { getItemDetails } from '../../actions/Items';
import placeholderImage from '../../assets/images/placeholder-sm.png';
import CONSTANTS from '../../constants';
import ImageHelper from '../../helpers/ImageHelper';
import OptionHelper from '../../helpers/OptionHelper';
import ViewHelper from '../../helpers/ViewHelper';
import AnalyticsService from '../../services/AnalyticsService';
import CartService from '../../services/CartService';
import Spinner from '../shared/Spinner';
import Comment from './Comment';
import ItemIntro from './ItemIntro';
import ItemWithPhoto from './ItemWithPhoto';
import ItemWithoutPhoto from './ItemWithoutPhoto';

class ItemModalDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      options: [],
      errors: [],
      quantity: 1,
      comment: ''
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      (!prevProps.item && this.props.item) ||
      prevProps.item?.menu_id !== this.props.item?.menu_id
    ) {
      const stateOptions = [];
      this.props.item.MenuOptions.forEach((option) => {
        option.Option_Values.forEach((optionValue) => {
          if (optionValue.checked === 'true')
            stateOptions.push(OptionHelper.optionObject(option, optionValue));
        });
      });
      this.setState({ options: stateOptions });
    }
  }

  toggleInstruction() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  getOptions() {
    return this.props.item.MenuOptions;
  }

  addOptions() {
    this.setState({ isOpen: true });
  }

  removeFromCart(item) {
    AnalyticsService.logEvent(CONSTANTS.EVENTS.ITEM.REMOVE, {
      category: CONSTANTS.EVENTS.ITEM.GROUP_NAME,
      locationId: this.props._location.slug,
      itemId: item.menu_id
    });

    CartService.removeItem(item);
    this.props.updateCart();
  }

  renderBanner(_location, menu, uploadedImages, itemQuantity, originalPrice, discountedPrice) {
    if (uploadedImages && uploadedImages.length > 0)
      return (
        <ItemWithPhoto
          grid_layout={this.props.grid_layout}
          _location={_location}
          uploadedImages={uploadedImages}
          itemQuantity={itemQuantity}
          menu={menu}
          locationSettings={this.props.locationSettings}
          isModal={true}
          originalPrice={originalPrice}
          discountedPrice={discountedPrice}
        />
      );
    return (
      <ItemWithoutPhoto
        grid_layout={this.props.grid_layout}
        _location={_location}
        locationSettings={this.props.locationSettings}
        uploadedImages={uploadedImages}
        itemQuantity={itemQuantity}
        menu={menu}
        isModal={true}
        originalPrice={originalPrice}
        discountedPrice={discountedPrice}
      />
    );
  }

  getReviews(itemDetails) {
    if (!itemDetails || !itemDetails.review_data) return null;
    return itemDetails.review_data;
  }

  getBannerImages(item, itemDetails) {
    if (itemDetails) return this.getItemImages(itemDetails.uploaded_images);
    if (item.menu_photo) return [item.menu_photo];
    return [];
  }

  getItemImages(images) {
    return images.map((image) => ImageHelper.getImageURL(image, '?func=crop&w=400&h=400'));
  }

  getCurrency() {
    return this.props._location.currency;
  }

  getDecimalPlaces() {
    return this.props._location.decimal_places;
  }

  renderPortion() {
    const portion = this.props.item?.Portion;
    if (portion) {
      if (this.props.grid_layout === 'old') {
        return (
          <div id={portion.portion_id} className="item-option">
            <div className="option-name f1 border-top border-bottom">
              {portion.label}
              {/* <span className="option-required f3 main-font-2">
                {'(Required)'}
              </span> */}
            </div>
            <div className="option-values row g-0">
              {this.renderPortionSizes()}
            </div>
          </div>
        );
      } else if (this.props.grid_layout !== 'old') {
        return (
          <div id={portion.portion_id} className="item-option" >
            <div className={`option-name f1 border-top border-bottom`}>
              <div
                className="option-name-title primary-font-color"
                style={{ display: 'flex', flexDirection: 'column' }}
              >
                {portion.label}
              </div>
              {/* <span className="option-required f3 main-font-2">
                {'(Required)'}
              </span> */}
            </div>
            <div className="option-values row g-0">
              {this.renderPortionSizes()}
            </div>
          </div>
        );
      }
    } else {
      return null;
    }
  }

  renderPortionSizes() {
    const portionSizes = this.props.item?.Portion?.PortionSizes;
    if (portionSizes) {
      return portionSizes.map((portionSize) => {
        if (this.props.grid_layout === 'old') {
          return (
            <Label className="f2 option-value" key={portionSize.portion_size_id}>
              <div className="option-value-name">{portionSize.label}</div>
              <div className="option-value-price card-font-color">
                {ViewHelper.toCurrency(
                  portionSize.price,
                  this.getCurrency(),
                  this.getDecimalPlaces()
                )}
              </div>
              <Input
                type="radio"
                name={portionSize.portion_size_id}
                checked={this.props.portionSize?.portion_size_id === portionSize.portion_size_id}
                onChange={this.props.onPortionSizeSelect.bind(this, portionSize)}
              />
            </Label>
          )
        } else {
          return (
            <StyledRadioGroup className="f2 option-value" key={portionSize.portion_size_id}>
              <div className="option-value-name">
                <div className="option-value-radio">
                  <input
                    type="radio"
                    name={portionSize.portion_size_id}
                    checked={this.props.portionSize?.portion_size_id === portionSize.portion_size_id}
                    onChange={this.props.onPortionSizeSelect.bind(this, portionSize)}
                  />
                  <span className="checkmark">
                    <span className="checkmark-circle"></span>
                  </span>
                </div>
                <h2 className="option-value-name-title option-value-name-title-pl card-font-color">
                  {portionSize.label}
                </h2>
              </div>
              <div className="option-value-price card-font-color">
                {ViewHelper.toCurrency(
                  portionSize.price,
                  this.getCurrency(),
                  this.getDecimalPlaces()
                )}
              </div>
            </StyledRadioGroup>
          )
        }
      });
    } else {
      return null;
    }
  }

  renderOptions(options) {
    return options.map((option, index) => {
      const gridImageLayout = option.OptionValues.some((option) => option.img !== null);
      if (option.OptionValues && option.OptionValues.length > 0 && option.status === 1) {
        if (this.props.grid_layout === 'old') {
          return (
            <div id={option.option_id} className="item-option" key={option.option_id}>
              <div className="option-name f1 border-top border-bottom primary-color primary-font-color">
                {option.option_name}
                <span className="option-required f3 card-subtitle-color">
                  {parseInt(option.required, 10) ? '(Required)' : ''}
                </span>
                <div className="f3 card-error-color">
                  {OptionHelper.getErrorMessage(this.props.errors, option)}
                </div>
              </div>
              <div
                className={
                  gridImageLayout && option.options_layout === 0 ? 'option-values row g-0 grid-image card-color  ' : 'option-values row g-0  card-color '
                }
              >
                {OptionHelper.isRadio(option) && this.renderRadioOptions(option)}
                {OptionHelper.isSelect(option) && this.renderSelectOptions(option)}
                {OptionHelper.isCheckbox(option) && this.renderCheckboxOptions(option)}
              </div>
            </div>
          );
        } else if (this.props.grid_layout !== 'old') {
          return (
            <div id={option.option_id} className="item-option" key={option.option_id}>
              <div className={`option-name option-name-${index + 1} f1 border-top border-bottom card-color`} style={{ display: 'flex', flexDirection: 'column' }}>
                <div
                  className="option-name-title primary-font-color"
                >
                  <div className={`highlight-color-active-outline p-2 rounded-pill`}>
                    {option.option_name}
                  </div>

                </div>
                <div className="f3 text-danger ms-2">
                  {OptionHelper.getErrorMessage(this.props.errors, option)}
                </div>
                {/* <span className="option-required f3 text-danger">
                  {'Required'}
                </span> */}
              </div>
              <div
                className={
                  gridImageLayout && option.options_layout === 0 ? 'option-values row g-0 grid-image card-color' : 'option-values row g-0 card-color'
                }
              >
                {OptionHelper.isRadio(option) && this.renderRadioOptions(option)}
                {OptionHelper.isSelect(option) && this.renderSelectOptions(option)}
                {OptionHelper.isCheckbox(option) && this.renderCheckboxOptions(option)}
              </div>
            </div>
          );
        }
      }
      return '';
    });
  }

  renderRadioOptions(option) {
    if (option.status === 0) return null;
    let optionValues = option.OptionValues;
    return optionValues.map((optionValue) => {
      if (this.props.grid_layout === 'old') {
        if (optionValue.status === 0) return null;
        let image = optionValue.img;
        return option.options_layout === 1 ? (
          <Label className="f2 option-value" key={optionValue.option_value_id}>
            <div className="option-value-name card-font-color">{optionValue.value}</div>
            <div className="option-value-price card-font-color">
              {ViewHelper.toCurrency(
                optionValue.price,
                this.getCurrency(),
                this.getDecimalPlaces()
              )}
            </div>
            <Input
              type="radio"
              checked={OptionHelper.isChecked(this.state.options, optionValue)}
              name={optionValue.option_id}
              onChange={this.onRadioSelect.bind(this, option, optionValue)}
            />
          </Label>
        ) : (
          <div className="col-4 align-items-center justify-content-center">
            <div className="f2 option-value option-value-space" style={{ width: '120px' }} key={optionValue.option_value_id}>
              <div
                className="text-center"
                style={{
                  position: 'relative'
                }}
                onClick={this.onRadioSelect.bind(this, option, optionValue)}
              >
                <LazyLoadImage
                  width="120px"
                  height="120px"
                  placeholderSrc={placeholderImage}
                  className="item-image rounded-lg"
                  src={ImageHelper.getImageURL(image, '?func=crop&w=180&h=180')}
                  alt={optionValue.value}
                  effect="blur"
                />
                {OptionHelper.isChecked(this.state.options, optionValue) && (
                  <span className="option-icon">
                    <FontAwesomeIcon
                      color={'var(--highlight-color)'}
                      icon={faCheckCircle}
                      size={'2x'}
                      style={{ background: 'var(--highlight-text-color)' }}
                      className='rounded-circle'
                    />
                  </span>
                )}
              </div>
              <div
                className="option-value-name-space text-break card-font-color"
                onClick={this.onRadioSelect.bind(this, option, optionValue)}
              >
                {optionValue.value}
              </div>
              &nbsp;
              <div className="option-value-price-space card-font-color">
                {ViewHelper.toCurrency(
                  optionValue.price,
                  this.getCurrency(),
                  this.getDecimalPlaces()
                )}
              </div>
            </div>
          </div>
        );
      } else {
        if (optionValue.status === 0) return null;
        let image = optionValue.img;
        return option.options_layout === 1 ? (
          <StyledRadioGroup className="f2 option-value" key={optionValue.option_value_id}>
            <div className="option-value-name card-font-color">
              <div className="option-value-radio">
                <input
                  type="radio"
                  checked={OptionHelper.isChecked(this.state.options, optionValue)}
                  name={optionValue.option_id}
                  onChange={this.onRadioSelect.bind(this, option, optionValue)}
                />
                <span className="checkmark">
                  <span className="checkmark-circle"></span>
                </span>
              </div>
              <h2 className="option-value-name-title option-value-name-title-pl card-font-color">
                {optionValue.value}
              </h2>
            </div>
            <div className="option-value-price card-font-color">
              {ViewHelper.toCurrency(
                optionValue.price,
                this.getCurrency(),
                this.getDecimalPlaces()
              )}
            </div>
          </StyledRadioGroup>
        ) : (
          <StyledRadioGroup
            className="col-4 col-md-4 d-inline-flex align-items-center justify-content-center f2 option-value"
            key={optionValue.option_value_id}
          >
            <div className="f2 option-value option-value-space" style={{ width: '120px' }} key={optionValue.option_value_id}>
              <div
                className="text-center"
                style={{
                  position: 'relative'
                }}
                onClick={this.onRadioSelect.bind(this, option, optionValue)}
              >
                <LazyLoadImage
                  width="120px"
                  height="120px"
                  placeholderSrc={placeholderImage}
                  className="item-image rounded-lg"
                  src={ImageHelper.getImageURL(image, '?func=crop&w=180&h=180')}
                  alt={optionValue.value}
                  effect="blur"
                />
                {OptionHelper.isChecked(this.state.options, optionValue) && (
                  <span className="option-icon">
                    <FontAwesomeIcon
                      color={'var(--highlight-color)'}
                      icon={faCheckCircle}
                      size={'2x'}
                      style={{ background: 'var(--highlight-text-color)' }}
                      className='rounded-circle'
                    />
                  </span>
                )}
              </div>
              <div
                className="option-value-name-space text-break card-font-color"
                onClick={this.onRadioSelect.bind(this, option, optionValue)}
              >
                {optionValue.value}
              </div>
              &nbsp;
              <div className="option-value-price-space card-font-color">
                {ViewHelper.toCurrency(
                  optionValue.price,
                  this.getCurrency(),
                  this.getDecimalPlaces()
                )}
              </div>
            </div>
          </StyledRadioGroup>
        );
      }
    });
  }

  renderCheckboxOptions(option) {
    if (option.status === 0) return null;
    let optionValues = option.OptionValues;
    return optionValues.map((optionValue) => {
      if (optionValue.status === 0) return null;
      let image = optionValue.img;
      if (this.props.grid_layout === 'old') {
        return option.options_layout === 1 ? (
          <Label className="f2 option-value" key={optionValue.option_value_id}>
            <div className="option-value-name card-font-color">{optionValue.value}</div>
            <div className="option-value-price card-font-color">
              {ViewHelper.toCurrency(
                optionValue.price,
                this.getCurrency(),
                this.getDecimalPlaces()
              )}
            </div>
            <Input
              type="checkbox"
              checked={OptionHelper.isChecked(this.state.options, optionValue)}
              name={optionValue.option_id}
              onChange={(event) => {
                event.target.checked
                  ? this.onSelectAdd(option, optionValue)
                  : this.onSelectRemove(option, optionValue);
              }}
            />
          </Label>
        ) : (
          <div className="col-4 d-flex align-items-center justify-content-center">
            <div className="f2 option-value option-value-space" style={{ width: '120px' }} key={optionValue.option_value_id}>
              <div
                className="text-center"
                style={{
                  position: 'relative'
                }}
                onClick={(event) => {
                  OptionHelper.isChecked(this.state.options, optionValue)
                    ? this.onSelectRemove(option, optionValue)
                    : this.onSelectAdd(option, optionValue);
                }}
              >
                <LazyLoadImage
                  width="120px"
                  height="120px"
                  placeholderSrc={placeholderImage}
                  className="item-image rounded-lg"
                  src={ImageHelper.getImageURL(image, '?func=crop&w=180&h=180')}
                  alt={optionValue.value}
                  effect="blur"
                />
                {OptionHelper.isChecked(this.state.options, optionValue) && (
                  <span className="option-icon">
                    <FontAwesomeIcon
                      color={'var(--highlight-color)'}
                      icon={faCheckCircle}
                      size={'2x'}
                      style={{ background: 'var(--highlight-text-color)' }}
                      className='rounded-circle'
                    />
                  </span>
                )}
              </div>
              <div
                className="option-value-name-space text-break card-font-color"
                onClick={(event) => {
                  OptionHelper.isChecked(this.state.options, optionValue)
                    ? this.onSelectRemove(option, optionValue)
                    : this.onSelectAdd(option, optionValue);
                }}
              >
                {optionValue.value}
              </div>
              &nbsp;
              <div className="option-value-price-space card-font-color">
                {ViewHelper.toCurrency(
                  optionValue.price,
                  this.getCurrency(),
                  this.getDecimalPlaces()
                )}
              </div>
            </div>
          </div>
        );
      } else {
        return option.options_layout === 1 ? (
          <Label className="f2 option-value" key={optionValue.option_value_id}>
            <div className="option-value-name card-font-color">
              <div className="option-value-select">
                <input
                  type="checkbox"
                  checked={OptionHelper.isChecked(this.state.options, optionValue)}
                  name={optionValue.option_id}
                  onChange={(event) => {
                    event.target.checked
                      ? this.onSelectAdd(option, optionValue)
                      : this.onSelectRemove(option, optionValue);
                  }}
                />
                <span className="checkmark">
                  <span className="checkmark-circle"></span>
                </span>
              </div>
              <h2 className="option-value-name-title option-value-name-title-pl card-font-color">
                {optionValue.value}
              </h2>
            </div>
            <div className="option-value-price card-font-color">
              {ViewHelper.toCurrency(
                optionValue.price,
                this.getCurrency(),
                this.getDecimalPlaces()
              )}
            </div>
          </Label>
        ) : (
          <div className="col-4 col-md-4 d-inline-flex align-items-center justify-content-center">
            <div className="f2 option-value option-value-space" style={{ width: '120px' }} key={optionValue.option_value_id}>
              <div
                className="text-center"
                style={{
                  position: 'relative'
                }}
                onClick={(event) => {
                  OptionHelper.isChecked(this.state.options, optionValue)
                    ? this.onSelectRemove(option, optionValue)
                    : this.onSelectAdd(option, optionValue);
                }}
              >
                <LazyLoadImage
                  width="120px"
                  height="120px"
                  placeholderSrc={placeholderImage}
                  className="item-image rounded-lg"
                  src={ImageHelper.getImageURL(image, '?func=crop&w=180&h=180')}
                  alt={optionValue.value}
                  effect="blur"
                />
                {OptionHelper.isChecked(this.state.options, optionValue) && (
                  <span className="option-icon">
                    <FontAwesomeIcon
                      color={'var(--highlight-color)'}
                      icon={faCheckCircle}
                      size={'2x'}
                      style={{ background: 'var(--highlight-text-color)' }}
                      className='rounded-circle'
                    />
                  </span>
                )}
              </div>
              <div
                className="option-value-name-space text-break card-font-color"
                onClick={(event) => {
                  OptionHelper.isChecked(this.state.options, optionValue)
                    ? this.onSelectRemove(option, optionValue)
                    : this.onSelectAdd(option, optionValue);
                }}
              >
                {optionValue.value}
              </div>
              &nbsp;
              <div className="option-value-price-space card-font-color">
                {ViewHelper.toCurrency(
                  optionValue.price,
                  this.getCurrency(),
                  this.getDecimalPlaces()
                )}
              </div>
            </div>
          </div>
        );
      }
    });
  }

  renderSelectOptions(option) {
    if (option.status === 0) return null;
    let optionValues = option.OptionValues;
    return optionValues.map((optionValue) => {
      if (this.props.grid_layout === 'old') {
        if (optionValue.status === 0) return null;
        let image = optionValue.img;
        return option.options_layout === 1 ? (
          <div className="f2 option-value option-value-select" key={optionValue.option_value_id}>
            <div
              className="option-value-name card-font-color"
              onClick={this.onSelectAdd.bind(this, option, optionValue)}
            >
              {OptionHelper.getFormattedQuantity(this.state.options, optionValue) !== '' && (
                <span className="option-value-quantity">
                  {OptionHelper.getFormattedQuantity(this.state.options, optionValue)}
                </span>
              )}
              {optionValue.value}
            </div>
            <div className="option-value-control">
              <span
                className="option-value-price card-font-color"
                onClick={this.onSelectAdd.bind(this, option, optionValue)}
              >
                {ViewHelper.toCurrency(
                  optionValue.price,
                  this.getCurrency(),
                  this.getDecimalPlaces()
                )}
              </span>
              {OptionHelper.getQuantity(this.state.options, optionValue) > 0 ? (
                <FontAwesomeIcon
                  color={'var(--card-error-color)'}
                  icon={faTrashAlt}
                  onClick={this.onSelectRemove.bind(this, option, optionValue)}
                />
              ) : (
                ''
              )}
            </div>
          </div>
        ) : (
          <div className="col-4 col-md-4 d-inline-flex align-items-center justify-content-center">
            <div className="f2 option-value option-value-space" style={{ width: '120px' }} key={optionValue.option_value_id}>
              <div
                className="text-center"
                onClick={this.onSelectAdd.bind(this, option, optionValue)}
              >
                <LazyLoadImage
                  width="120px"
                  height="120px"
                  placeholderSrc={placeholderImage}
                  className="item-image rounded-lg"
                  src={ImageHelper.getImageURL(image, '?func=crop&w=180&h=180')}
                  effect="blur"
                />
              </div>
              <div
                className="option-value-name-space text-break card-font-color"
                onClick={this.onSelectAdd.bind(this, option, optionValue)}
              >
                {/* <span className='option-value-quantity'>{OptionHelper.getFormattedQuantity(this.state.options, optionValue)}</span> */}
                {optionValue.value}
              </div>
              &nbsp;
              <div className="option-value-price-space card-font-color">
                {ViewHelper.toCurrency(
                  optionValue.price,
                  this.getCurrency(),
                  this.getDecimalPlaces()
                )}
              </div>
              <div className="option-value-name-space">
                {OptionHelper.getFormattedQuantity(this.state.options, optionValue) && (
                  <>
                    <button type="button" className="option-value-btn">
                      <FontAwesomeIcon
                        color={'var(--button-color)'}
                        icon={faMinusCircle}
                        size={'lg'}
                        onClick={this.onSelectRemove.bind(this, option, optionValue)}
                      />
                    </button>
                    &nbsp;
                    <span className="option-value-quantity">
                      {OptionHelper.getFormattedQuantityWithoutX(this.state.options, optionValue)}
                    </span>
                    <button type="button" className="option-value-btn">
                      <FontAwesomeIcon
                        color={'var(--button-color)'}
                        size={'lg'}
                        icon={faPlusCircle}
                        onClick={this.onSelectAdd.bind(this, option, optionValue)}
                      />
                    </button>
                  </>
                )}
                {!OptionHelper.getFormattedQuantity(this.state.options, optionValue) && (
                  <button
                    type="button"
                    class="col-lg-10 btn-xs btn btn-outline-secondary add-button branding-btn-simple"
                    onClick={this.onSelectAdd.bind(this, option, optionValue)}
                  >
                    Add
                  </button>
                )}
              </div>
            </div>
          </div>
        );
      } else {
        if (optionValue.status === 0) return null;
        let image = optionValue.img;
        return option.options_layout === 1 ? (
          <div className="f2 option-value option-value-select" key={optionValue.option_value_id}>
            <div
              className="option-value-name"
              onClick={this.onSelectAdd.bind(this, option, optionValue)}
            >
              {OptionHelper.getFormattedQuantity(this.state.options, optionValue) !== '' && (
                <span className="option-value-quantity">
                  {OptionHelper.getFormattedQuantity(this.state.options, optionValue)}
                </span>
              )}
              <h2 className="option-value-name-title card-font-color">{optionValue.value}</h2>
            </div>
            <div className="option-value-control">
              <span
                className="option-value-price card-font-color"
                onClick={this.onSelectAdd.bind(this, option, optionValue)}
              >
                {ViewHelper.toCurrency(
                  optionValue.price,
                  this.getCurrency(),
                  this.getDecimalPlaces()
                )}
              </span>
              {OptionHelper.getQuantity(this.state.options, optionValue) > 0 ? (
                <FontAwesomeIcon
                  color={'var(--card-error-color)'}
                  icon={faTrashAlt}
                  onClick={this.onSelectRemove.bind(this, option, optionValue)}
                />
              ) : (
                ''
              )}
            </div>
          </div>
        ) : (
          <div className="col-4 col-md-4 d-inline-flex align-items-center justify-content-center">
            <div className="f2 option-value option-value-space" style={{ width: '120px' }} key={optionValue.option_value_id}>
              <div
                className="text-center"
                onClick={this.onSelectAdd.bind(this, option, optionValue)}
              >
                <LazyLoadImage
                  width="120px"
                  height="120px"
                  placeholderSrc={placeholderImage}
                  className="item-image rounded-lg"
                  src={ImageHelper.getImageURL(image, '?func=crop&w=180&h=180')}
                  alt={optionValue.value}
                  effect="blur"
                />
              </div>
              <div
                className="option-value-name-space text-break card-font-color"
                onClick={this.onSelectAdd.bind(this, option, optionValue)}
              >
                {/* <span className='option-value-quantity'>{OptionHelper.getFormattedQuantity(this.state.options, optionValue)}</span> */}
                {optionValue.value}
              </div>
              &nbsp;
              <div className="option-value-price-space card-font-color">
                {ViewHelper.toCurrency(
                  optionValue.price,
                  this.getCurrency(),
                  this.getDecimalPlaces()
                )}
              </div>
              <div className="option-value-name-space">
                {OptionHelper.getFormattedQuantity(this.state.options, optionValue) && (
                  <>
                    <button type="button" className="option-value-btn">
                      <FontAwesomeIcon
                        color={'var(--button-color)'}
                        icon={faMinusCircle}
                        size={'lg'}
                        onClick={this.onSelectRemove.bind(this, option, optionValue)}
                      />
                    </button>
                    &nbsp;
                    <span className="option-value-quantity">
                      {OptionHelper.getFormattedQuantityWithoutX(this.state.options, optionValue)}
                    </span>
                    <button type="button" className="option-value-btn">
                      <FontAwesomeIcon
                        color={'var(--button-color)'}
                        size={'lg'}
                        icon={faPlusCircle}
                        onClick={this.onSelectAdd.bind(this, option, optionValue)}
                      />
                    </button>
                  </>
                )}
                {!OptionHelper.getFormattedQuantity(this.state.options, optionValue) && (
                  <button
                    type="button"
                    class="col-lg-10 btn-xs btn btn-outline-secondary add-button branding-btn-simple"
                    onClick={this.onSelectAdd.bind(this, option, optionValue)}
                  >
                    Add
                  </button>
                )}
              </div>
            </div>
          </div>
        );
      }
    });
  }

  // Input Select Functions
  onRadioSelect(selectedOption, selectedOptionValue) {
    let options = this.state.options;
    // Update option value
    _.remove(options, (option) => option.option_id === selectedOption.option_id);
    options.push(OptionHelper.optionObject(selectedOption, selectedOptionValue));

    // Clear validation errors for this option
    let errors = OptionHelper.clearError(this.state.errors, selectedOption);
    this.setState({ options, errors });
    this.props.onRselect(selectedOption, selectedOptionValue);
  }

  onSelectAdd(selectedOption, selectedOptionValue) {
    let options = this.state.options;
    if (OptionHelper.canAddOption(options, selectedOption)) {
      options.push(OptionHelper.optionObject(selectedOption, selectedOptionValue));

      // Clear validation errors for this option
      let errors = OptionHelper.clearError(this.state.errors, selectedOption);
      this.setState({ options, errors });
    } else {
      this.setState({
        errors: [
          {
            option_id: selectedOption.option_id,
            message: `You can only select ${selectedOption.max} ${selectedOption.option_name}`
          }
        ]
      });
    }
    this.props.onSelect(selectedOption, selectedOptionValue);
  }

  onSelectRemove(selectedOption, selectedOptionValue) {
    let options = this.state.options;
    // Remove last occurrence of this option value
    const alreadySelected = _.findLastIndex(
      options,
      (option) => option.option_value_id === selectedOptionValue.option_value_id
    );
    if (alreadySelected > -1) _.pullAt(options, [alreadySelected]);

    // Clear validation errors for this option
    let errors = OptionHelper.clearError(this.state.errors, selectedOption);
    this.setState({ options, errors });
    this.props.onSelectRemove(selectedOption, selectedOptionValue);
  }

  onCommentChange(event) {
    this.setState({ [event.target.name]: event.target.value });
    this.props.onComment(event);
  }

  render() {
    let { _location, item, itemDetails } = this.props;
    if (_location && item) {
      let menu = item;
      let options = item.MenuOptions;
      let bannerImages = this.getBannerImages(item, itemDetails);
      const originalPrice = OptionHelper.optionsTotal(
        item,
        this.state.options,
        this.props.quantity,
        this.props.portionSize
      );
      const discountedPrice = item.discounts
        ? item.discounts.discountAmountType ===
          CONSTANTS.PROMOTIONS.VARIABLES.DISCOUNTS.AMOUNT_TYPE.FIXED
          ? originalPrice - item.discounts.discountAmount
          : originalPrice - (originalPrice * item.discounts.discountAmount) / 100
        : originalPrice;
      const originalPriceLabel = ViewHelper.toCurrency(
        originalPrice,
        _location.currency,
        _location.decimal_places
      );
      const discountedPriceLabel = ViewHelper.toCurrency(
        discountedPrice,
        _location.currency,
        _location.decimal_places
      );
      const price = ViewHelper.toCurrency(
        this.props.portionSize ? this.props.portionSize.price : menu.menu_price,
        _location.currency,
        _location.decimal_places
      );
      const discounted = ViewHelper.toCurrency(
        menu.discounts.discountedPrice,
        _location.currency,
        _location.decimal_places
      );
      const branding_btn = this.props.locationSettings.btn_outline_enable === 1 ? 'branding-btn-outline' : 'branding-btn';
      if (this.props.grid_layout === 'old') {
        return (
          <React.Fragment>
            {bannerImages.length > 0 ? (
              <div className="container card-color">
                <div id="modal-start" />
                <div className="row">
                  <div className="col-lg-6 gx-0">
                    <div className="sticky-top">
                      {this.renderBanner(_location, menu, bannerImages, this.props.quantity, originalPrice, discountedPrice)}
                    </div>
                  </div>
                  <div className="col-lg-6 gx-0 col-display" style={{ overflowX: 'clip' }}>
                    <div className="item-detail">
                      <div className="item-int d-none d-sm-none d-md-none d-lg-block">
                        <ItemIntro
                          itemQuantity={this.props.quantity}
                          menu={menu}
                          location={_location}
                          key="intro"
                          portionSize={this.props.portionSize}
                        />

                        <div className="f1 item-price-modal item-price d-none d-sm-none d-md-none d-lg-block card-font-color">
                          {menu.menu_price === menu.discounts.discountedPrice ? (
                            price
                          ) : (
                            <>
                              <span className="card-font-color">{discounted}</span>{' '}
                              <span className="text-decoration-line-through">{price}</span>
                            </>
                          )}
                        </div>
                      </div>
                      {menu.menu_description !== '' && (
                        <div
                          className="f2 col-12 item-description custom-item-description card-color card-subtitle-color"
                          style={{
                            boxShadow: options.length === 0 && 'unset !important'
                          }}
                        >
                          {menu.menu_description}
                        </div>
                      )}
                      {_location.location_status && [
                        // options.length === 0 && menu.menu_status != 2 ? <div className='separator'/>:'',
                        menu.menu_status === 2 ? (
                          <p className="text-center card-error-color" style={{ paddingTop: '20px' }}>
                            Item Unavailable
                          </p>
                        ) : (
                          ''
                        ),
                        _location.location_status &&
                          options.length === 0 &&
                          menu.menu_status !== 2 ? (
                          <React.Fragment>
                            {/*{this.state.comment !== "" && <h2 className={"special-instruction"}>Add Special Instruction</h2>}*/}
                            {this.state.isOpen && (
                              <Comment
                                value={this.state.comment}
                                type="textarea"
                                locationSettings={this.props.locationSettings}
                                onChange={this.onCommentChange.bind(this)}
                              />
                            )}
                            {/*{this.state.comment !== "" && <div className='separator no-shadow'/>}*/}
                          </React.Fragment>
                        ) : (
                          ''
                        )
                      ]}
                    </div>

                    {this.props.item?.Portion && (
                      <div className="item-options card-color">
                        <div className="item-options-container-custom">
                          {this.renderPortion()}
                        </div>
                      </div>
                    )}
                    {_location.location_status && options.length > 0 && menu.menu_status !== 2 && (
                      <div className="item-options card-color">
                        <div className="item-options-container-custom">
                          {this.renderOptions(options)}
                        </div>
                        <h2 className={'special-instruction card-color card-subtitle-color'}>Special Instruction</h2>
                        <Comment
                          value={this.state.comment}
                          type="textarea"
                          locationSettings={this.props.locationSettings}
                          onChange={this.onCommentChange.bind(this)}
                        />
                      </div>
                    )}
                    {options.length === 0 && menu.menu_status !== 2 && (
                      <div className={'item-options card-color'}>
                        <h2
                          className={'special-instruction special-instruction-without-option card-color'}
                          style={{ padding: '20px 30px !important' }}
                        >
                          Special Instruction
                        </h2>
                        <Comment
                          value={this.state.comment}
                          type="textarea"
                          locationSettings={this.props.locationSettings}
                          onChange={this.onCommentChange.bind(this)}
                        />
                      </div>
                    )}

                    <div className="container-fluid d-none d-sm-none d-md-none d-lg-block sticky-bottom add-to-cart-shadow card-color">
                      <div className="row">
                        {!_location.location_status ||
                          menu.menu_status === 2 ||
                          (menu.daily_limit === 0 && _location.is_homecheff) ||
                          !this.props.isOrderingEnabled ? (
                          <div>
                            <Button
                              className={`col-lg-12 btn-lg ${branding_btn}`}
                              color="secondary"
                              onClick={this.props.onModalClose}
                            >
                              Cancel
                            </Button>
                          </div>
                        ) : (
                          <div className="add-order">
                            <div className="custom-increment-decrement">
                              <div
                                className={`custom-increment-decrement__decrement ${branding_btn}`}
                                onClick={this.props.onDecrement}
                              >
                                <span>&#8722;</span>
                              </div>
                              <div className={`custom-increment-decrement__quantity ${branding_btn}`}>
                                <p>{this.props.quantity}</p>
                              </div>
                              <div
                                className={`custom-increment-decrement__increment ${branding_btn}`}
                                onClick={this.props.onIncrement}
                              >
                                <span>&#43;</span>
                              </div>
                            </div>
                            <div
                              className={`item-modal-add-item ${branding_btn}`}
                              onClick={this.props.addOptionsAndGoBack}
                            >
                              <h2 className="branding-btn-font-color">
                                Add to Cart -&nbsp;
                                {originalPrice === discountedPrice ? (
                                  originalPriceLabel
                                ) : (
                                  <>
                                    <span className="branding-btn-font-color ml-4">
                                      {discountedPriceLabel}
                                    </span>
                                    &nbsp;
                                    <span className="text-decoration-line-through card-subtitle-color ml-1 form-control-sm font-weight-lighter">
                                      {originalPriceLabel}
                                    </span>
                                  </>
                                )}
                              </h2>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="background-white card-color" style={{ overflowX: 'clip' }}>
                <div id="modal-start" />
                <div className="item-detail">
                  {this.renderBanner(_location, menu, bannerImages, originalPrice, discountedPrice)}
                  <div className="f2 col-12 item-description card-color">{menu.menu_description}</div>
                  {_location.location_status && [
                    options.length === 0 && menu.menu_status !== 2 ? (
                      ''
                    ) : (
                      ''
                    ),
                    menu.menu_status === 2 ? (
                      <p className="text-center card-error-color">Item Unavailable</p>
                    ) : (
                      ''
                    ),
                    _location.location_status && options.length === 0 && menu.menu_status !== 2 ? (
                      <React.Fragment>
                        {/* <QuantityModifier
                          key={'modifier'}
                          item={menu}
                          quantity={this.props.quantity}
                          options={options}
                          addOptions={this.addOptions.bind(this)}
                          addToCart={this.props.onIncrement.bind(this)}
                          removeFromCart={this.props.onDecrement.bind(this)}
                        /> */}
                        {this.state.isOpen && (
                          <Comment
                            value={this.state.comment}
                            type="textarea"
                            locationSettings={this.props.locationSettings}
                            onChange={this.onCommentChange.bind(this)}
                          />
                        )}
                      </React.Fragment>
                    ) : (
                      ''
                    )
                  ]}
                </div>
                {this.props.item?.Portion && (
                  <div className="item-options  card-color">
                    <div className="item-options-container">{this.renderPortion()}</div>
                  </div>
                )}
                {_location.location_status && menu.menu_status !== 2 && (
                  <div className="item-options  card-color">
                    <div className="item-options-container">{this.renderOptions(options)}</div>
                    <Comment
                      value={this.state.comment}
                      type="textarea"
                      locationSettings={this.props.locationSettings}
                      onChange={this.onCommentChange.bind(this)}
                    />
                    {/* <QuantityModifier
                      key={'modifier'}
                      quantity={this.props.quantity}
                      item={item}
                      addToCart={this.props.onIncrement.bind(this)}
                      removeFromCart={this.props.onDecrement.bind(this)}
                    /> */}
                  </div>
                )}
                <div className="container-fluid d-none d-sm-none d-md-none d-lg-block sticky-bottom add-to-cart-shadow card-color">
                  <div className="row">
                    {!_location.location_status ||
                      menu.menu_status === 2 ||
                      (menu.daily_limit === 0 && _location.is_homecheff) ||
                      !this.props.isOrderingEnabled ? (
                      <div>
                        <Button
                          className={`col-lg-12 btn-lg ${branding_btn}`}
                          color="secondary"
                          onClick={this.props.onModalClose}
                        >
                          Cancel
                        </Button>
                      </div>
                    ) : (
                      <div className="add-order">
                        <div className="custom-increment-decrement">
                          <div
                            className={`custom-increment-decrement__decrement card-subtitle-color ${branding_btn}`}
                            onClick={this.props.onDecrement}
                          >
                            <span className='branding-btn-font-color'>&#8722;</span>
                          </div>
                          <div className={`custom-increment-decrement__quantity ${branding_btn}`}>
                            <p>{this.props.quantity}</p>
                          </div>
                          <div
                            className={`custom-increment-decrement__increment card-subtitle-color ${branding_btn}`}
                            onClick={this.props.onIncrement}
                          >
                            <span className='branding-btn-font-color'>&#43;</span>
                          </div>
                        </div>
                        <div
                          className={`item-modal-add-item  ${branding_btn}`}
                          onClick={this.props.addOptionsAndGoBack}
                        >
                          <h2 className="branding-btn-font-color">
                            Add to Cart -&nbsp;
                            {originalPrice === discountedPrice ? (
                              originalPriceLabel
                            ) : (
                              <>
                                <span className="branding-btn-font-color ml-4">
                                  {discountedPriceLabel}
                                </span>
                                &nbsp;
                                <span className="text-decoration-line-through card-subtitle-color ml-1 form-control-sm font-weight-lighter">
                                  {originalPriceLabel}
                                </span>
                              </>
                            )}
                          </h2>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </React.Fragment>
        );
      } else if (this.props.grid_layout !== 'old') {
        return (
          <React.Fragment>
            {bannerImages.length > 0 ? (
              <div className="container card-color">
                <div id="modal-start" />
                <div className="row">
                  <div className="col-lg-6 gx-0">
                    <div className="item-detail sticky-top">
                      {this.renderBanner(_location, menu, bannerImages, this.props.quantity, originalPrice, discountedPrice)}
                    </div>
                  </div>
                  <div className="col-lg-6 gx-0 col-display" style={{ overflowX: 'clip' }}>
                    <div className="item-detail">
                      <div id={menu.menu_id} className="item-int d-none d-sm-none d-md-none d-lg-block">
                        <ItemIntro
                          itemQuantity={this.props.quantity}
                          menu={menu}
                          location={_location}
                          key="intro"
                        />
                        <div className="f1 item-price-modal item-price d-none d-sm-none d-md-none d-lg-block card-font-colo">
                          {!this.props.isReward ?

                            menu.menu_price == menu.discounts.discountedPrice ? (
                              price
                            ) : (
                              <>
                                <span className="font-color-primary">{discounted}</span>{' '}
                                <span className="text-decoration-line-through">{price}</span>
                                <div className="f3 text-danger">
                                  {OptionHelper.getErrorMessageForDailyStock(this.props.errors, menu.menu_id)}
                                </div>
                              </>
                            )
                            :
                            ViewHelper.toCurrencyWithZero(
                              0,
                              _location.currency,
                              _location.decimal_places
                            )
                          }
                        </div>
                      </div>
                      {menu.menu_description !== '' && (
                        <div
                          className="f2 col-12 item-description custom-item-description card-color card-subtitle-color"
                          style={{
                            boxShadow: options.length === 0 && 'unset !important'
                          }}
                        >
                          {menu.menu_description}
                        </div>
                      )}
                      {_location.location_status && [
                        // options.length === 0 && menu.menu_status != 2 ? <div className='separator'/>:'',
                        menu.menu_status === 2 ? (
                          <p className="text-center card-error-color" style={{ paddingTop: '20px' }}>
                            Item Unavailable
                          </p>
                        ) : (
                          ''
                        ),
                        _location.location_status &&
                          options.length === 0 &&
                          menu.menu_status !== 2 ? (
                          <React.Fragment>
                            {/*{this.state.comment !== "" && <h2 className={"special-instruction"}>Add Special Instruction</h2>}*/}
                            {this.state.isOpen && (
                              <Comment
                                value={this.state.comment}
                                type="textarea"
                                locationSettings={this.props.locationSettings}
                                onChange={this.onCommentChange.bind(this)}
                              />
                            )}
                            {/*{this.state.comment !== "" && <div className='separator no-shadow'/>}*/}
                          </React.Fragment>
                        ) : (
                          ''
                        )
                      ]}
                    </div>
                    {this.props.item?.Portion && (
                      <div className="item-options  card-color">
                        <div className="item-options-container-custom">
                          {this.renderPortion()}
                        </div>
                      </div>
                    )}
                    {_location.location_status && options.length > 0 && menu.menu_status !== 2 && (
                      <div className="item-options  card-color">
                        <div className="item-options-container-custom">
                          {this.renderOptions(options)}
                        </div>
                        <h2 className={'special-instruction card-color card-subtitle-color'}>Special Instruction</h2>
                        <Comment
                          value={this.state.comment}
                          type="textarea"
                          locationSettings={this.props.locationSettings}
                          onChange={this.onCommentChange.bind(this)}
                        />
                      </div>
                    )}
                    {options.length === 0 && menu.menu_status !== 2 && (
                      <div className={'item-options  card-color'}>
                        <h2
                          className={'special-instruction special-instruction-without-option card-color card-subtitle-color'}
                          style={{ padding: '20px 30px !important' }}
                        >
                          Special Instruction
                        </h2>
                        <Comment
                          value={this.state.comment}
                          type="textarea"
                          locationSettings={this.props.locationSettings}
                          onChange={this.onCommentChange.bind(this)}
                        />
                      </div>
                    )}

                    <div className="container-fluid d-none d-sm-none d-md-none d-lg-block sticky-bottom add-to-cart-shadow card-color">
                      <div className="row">
                        {!_location.location_status ||
                          menu.menu_status === 2 ||
                          (menu.daily_limit === 0 && _location.is_homecheff) ||
                          !this.props.isOrderingEnabled ? (
                          <div>
                            <Button
                              className={`col-lg-12 btn-lg ${branding_btn}`}
                              color="secondary"
                              onClick={this.props.onModalClose}
                            >
                              Cancel
                            </Button>{' '}
                          </div>
                        ) : (
                          <div className="add-order">
                            {!this.props.isReward ?
                              <div className="custom-increment-decrement">
                                <div
                                  className="custom-increment-decrement__decrement"
                                  onClick={this.props.onDecrement}
                                >
                                  <span>&#8722;</span>
                                </div>
                                <div className="custom-increment-decrement__quantity">
                                  <p>{this.props.quantity}</p>
                                </div>
                                <div
                                  className="custom-increment-decrement__increment"
                                  onClick={this.props.onIncrement}
                                >
                                  <span>&#43;</span>
                                </div>
                              </div> : ''
                            }
                            {!this.props.isReward ?
                              <div
                                className={`item-modal-add-item ${this.props.isReward ? 'item-modal-reward' : ''} ${branding_btn}`}
                                onClick={this.props.addOptionsAndGoBack}
                              >
                                <h2 className="branding-btn-font-color">
                                  Add to Cart -&nbsp;
                                  {originalPrice === discountedPrice ? (
                                    originalPriceLabel
                                  ) : (
                                    <>
                                      <span className="branding-btn-font-color ml-4">
                                        {discountedPriceLabel}
                                      </span>
                                      &nbsp;
                                      <span className="text-decoration-line-through card-subtitle-color ml-1 form-control-sm font-weight-lighter">
                                        {originalPriceLabel}
                                      </span>
                                    </>
                                  )}
                                </h2>
                              </div> :
                              <div
                                className={`item-modal-add-item item-modal-reward ${branding_btn}`}
                                onClick={this.props.addOptionsAndGoBack}
                              >
                                <h2 className="">
                                  Add to Cart
                                </h2>
                              </div>
                            }
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="background-white" style={{ overflowX: 'clip' }}>
                <div id="modal-start" />
                <div className="item-detail">
                  {this.renderBanner(_location, menu, bannerImages, this.props.quantity, originalPrice, discountedPrice)}
                  {menu.menu_description !== '' && (
                    <div
                      className="f2 col-12 item-description custom-item-description card-color card-subtitle-color"
                      style={{
                        boxShadow: options.length === 0 && 'unset !important'
                      }}
                    >
                      {menu.menu_description}
                    </div>
                  )}
                  {_location.location_status && [
                    // options.length === 0 && menu.menu_status != 2 ? <div className='separator'/>:'',
                    menu.menu_status === 2 ? (
                      <p className="text-center card-error-color" style={{ paddingTop: '20px' }}>
                        Item Unavailable
                      </p>
                    ) : (
                      ''
                    ),
                    _location.location_status && options.length === 0 && menu.menu_status !== 2 ? (
                      <React.Fragment>
                        {/*{this.state.comment !== "" && <h2 className={"special-instruction"}>Add Special Instruction</h2>}*/}
                        {this.state.isOpen && (
                          <Comment
                            value={this.state.comment}
                            type="textarea"
                            locationSettings={this.props.locationSettings}
                            onChange={this.onCommentChange.bind(this)}
                          />
                        )}
                        {/*{this.state.comment !== "" && <div className='separator no-shadow'/>}*/}
                      </React.Fragment>
                    ) : (
                      ''
                    )
                  ]}
                </div>
                {this.props.item?.Portion && (
                  <div className="item-options card-color">
                    <div className="item-options-container-custom">
                      {this.renderPortion()}
                    </div>
                  </div>
                )}
                {_location.location_status && options.length > 0 && menu.menu_status !== 2 && (
                  <div className="item-options card-color">
                    <div className="item-options-container-custom">
                      {this.renderOptions(options)}
                    </div>
                    <h2 className={'special-instruction card-color card-subtitle-color'}>Special Instruction</h2>
                    <Comment
                      value={this.state.comment}
                      type="textarea"
                      locationSettings={this.props.locationSettings}
                      onChange={this.onCommentChange.bind(this)}
                    />
                  </div>
                )}
                {options.length === 0 && menu.menu_status !== 2 && (
                  <div className={'item-options  card-color'}>
                    <h2
                      className={'special-instruction special-instruction-without-option card-color'}
                      style={{ padding: '20px 30px !important' }}
                    >
                      Special Instruction
                    </h2>
                    <Comment
                      value={this.state.comment}
                      type="textarea"
                      locationSettings={this.props.locationSettings}
                      onChange={this.onCommentChange.bind(this)}
                    />
                  </div>
                )}
                <div className="container-fluid d-none d-sm-none d-md-none d-lg-block sticky-bottom add-to-cart-shadow card-color">
                  <div className="row">
                    {!_location.location_status ||
                      menu.menu_status === 2 ||
                      (menu.daily_limit === 0 && _location.is_homecheff) ||
                      !this.props.isOrderingEnabled ? (
                      <div>
                        <Button
                          className={`col-lg-12 btn-lg ${branding_btn}`}
                          color="secondary"
                          onClick={this.props.onModalClose}
                        >
                          Cancel
                        </Button>
                      </div>
                    ) : (
                      <div className="add-order">
                        {!this.props.isReward ?

                          <div className="custom-increment-decrement">
                            <div
                              className="custom-increment-decrement__decrement"
                              onClick={this.props.onDecrement}
                            >
                              <span>&#8722;</span>
                            </div>
                            <div className="custom-increment-decrement__quantity">
                              <p>{this.props.quantity}</p>
                            </div>
                            <div
                              className="custom-increment-decrement__increment"
                              onClick={this.props.onIncrement}
                            >
                              <span>&#43;</span>
                            </div>
                          </div> : ''
                        }
                        {!this.props.isReward ?
                          <div
                            className={`item-modal-add-item ${this.props.isReward ? 'item-modal-reward' : ''} ${branding_btn}`}
                            onClick={this.props.addOptionsAndGoBack}
                          >
                            <h2 className="">
                              Add to Cart -&nbsp;
                              {originalPrice === discountedPrice ? (
                                originalPriceLabel
                              ) : (
                                <>
                                  <span className="font-color-white ml-4">
                                    {discountedPriceLabel}
                                  </span>
                                  &nbsp;
                                  <span className="text-decoration-line-through font-color-white ml-1 form-control-sm font-weight-lighter">
                                    {originalPriceLabel}
                                  </span>
                                </>
                              )}
                            </h2>
                          </div> :
                          <div
                            className={`item-modal-add-item ${branding_btn}`}
                            onClick={this.props.addOptionsAndGoBack}
                          >
                            <h2 className="">
                              Add to Cart
                            </h2>
                          </div>
                        }
                      </div>
                    )}
                  </div>
                </div >
              </div >
            )
            }
          </React.Fragment >
        );
      }
    }
    return <Spinner size={40} />;
  }
}

const StyledRadioGroup = styled(Label)``;
function mapStateToProps(state) {
  const { itemDetails } = state;
  return { itemDetails };
}
export default connect(mapStateToProps, { getItemDetails })(ItemModalDetail);
